export const LMS_CHAPTERS_RESET_STATE = 'LMS_CHAPTERS_RESET_STATE';
export const LMS_CHAPTERS_CURRENT_ITEM = 'LMS_CHAPTERS_CURRENT_ITEM';

export const LMS_CHAPTERS_REQUEST_LOADING = 'LMS_CHAPTERS_REQUEST_LOADING';
export const LMS_CHAPTERS_REQUEST_SUCCESS = 'LMS_CHAPTERS_REQUEST_SUCCESS';
export const LMS_CHAPTERS_REQUEST_FAILED = 'LMS_CHAPTERS_REQUEST_FAILED';

export const LMS_CHAPTERS_CURRENT_ACTION = 'LMS_CHAPTERS_CURRENT_ACTION';
export const LMS_CHAPTERS_RESET_ACTION = 'LMS_CHAPTERS_RESET_ACTION';
